/* =====================================================================
 * docxPreviewRendererSlot — host-provided DOCX view engine DI seam.
 *
 * `FilePreviewPanel`은 shared 패키지라 enterprise 앱 아래의 문서에이전트
 * vendor 엔진을 직접 import할 수 없다. 호스트가 bootstrap 시점에 이 슬롯에
 * read-only renderer를 등록하면 통합에이전트 미리보기가 같은 엔진을 쓰고,
 * 등록하지 않은 호스트는 기존 lightweight renderer로 안전하게 fallback한다.
 * ===================================================================== */

import type React from 'react';

export interface DocxPreviewRendererProps {
  file: File;
  onLoadComplete?: () => void;
  onLoadStart?: () => void;
  onError?: (message: string) => void;
}

export type DocxPreviewRendererComponent =
  React.ComponentType<DocxPreviewRendererProps>;

let _impl: DocxPreviewRendererComponent | null = null;

/** 앱이 최초 React render 전에 한 번 등록한다. null은 기본 renderer 복원. */
export function setDocxPreviewRendererComponent(
  component: DocxPreviewRendererComponent | null,
): void {
  _impl = component;
}

export function getDocxPreviewRendererComponent(): DocxPreviewRendererComponent | null {
  return _impl;
}

/** render 시점의 host override 또는 호출자가 준 기본 구현을 선택한다. */
export function resolveDocxPreviewRendererComponent(
  fallback: DocxPreviewRendererComponent,
): DocxPreviewRendererComponent {
  return _impl ?? fallback;
}
